import { useEffect,useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Login from "../components/Login";
import Footer from "../components/Footer";


export default function LoginPage() {
  const navigate = useNavigate();

  useLayoutEffect(()=>{
      const userString = sessionStorage.getItem("user");
      const role = userString ? JSON.parse(userString).role : null;
      
     if(userString){
      navigate('/')
     }
  },[])
  return (
    <div className="home vh100 login"> 
      <Login/>
      <Footer/>
    </div>
  );
}
